/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Jump_Bullet_3Inputs */

const en_features_jump_bullet_3 = /** @type {(inputs: Features_Jump_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of course, you can also listen to entire papers from top to bottom`)
};

const es_features_jump_bullet_3 = /** @type {(inputs: Features_Jump_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por supuesto, también puedes escuchar artículos completos de principio a fin`)
};

/**
* | output |
* | --- |
* | "Of course, you can also listen to entire papers from top to bottom" |
*
* @param {Features_Jump_Bullet_3Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_jump_bullet_3 = /** @type {((inputs?: Features_Jump_Bullet_3Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Jump_Bullet_3Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_jump_bullet_3(inputs)
	return en_features_jump_bullet_3(inputs)
});